import { Button } from "@mui/base";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Multiselect from "multiselect-react-dropdown";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../AxiosInstance/AxiosInstance";

import {
  ADD_ANON_PROTOCOL,
  GET_DICOM_TAGS,
  UPDATE_ANON_PROTOCOL,
} from "../../appConstants";
import "../Modal/Modal.css";

const AddProtocolModal = (props) => {
  const { editData, handleclickcustom } = props;

  const [name, setName] = useState("");
  const [showPreserveTags, setshowPreserveTags] = useState(false);
  const [data, setData] = useState();
  const [preservetaglist, setpreservetaglist] = useState("");
  const [excludetaglist, setexcludetaglist] = useState("");
  const [fixedValue, setFixedValue] = useState([]);
  const [data2, setData2] = useState();
  const [data3, setData3] = useState();
  const [data4, setData4] = useState();
  const [data5, setData5] = useState();
  const [data6, setData6] = useState();
  const [rules, setRules] = useState([]);
  const [fixedSelectedValue, setfixedSelectedValue] = useState();
  const [id, setId] = React.useState("");
  const [error, seterror] = useState(false);
  const [fixedError, setfixedError] = useState(false);
  const [editHash, setEditHash] = useState([]);
  const [editRemove, setEditRemove] = useState([]);
  const [editEmpty, setEditEmpty] = useState([]);
  const [editPreserve, setEditPreserve] = useState([]);
  const [editexclude, setEditexclude] = useState([]);
  const [editFixedValue, setEditFixedValue] = useState([]);
  const [flag, setFlag] = useState(true);

  useEffect(() => {
    if (
      Object.keys(editData).length &&
      data &&
      data2 &&
      data3 &&
      data4 &&
      data5 &&
      data6 &&
      flag
    ) {
      setFlag(false);

      const rules = JSON.parse(editData.rules);

      // Function to apply rules to data
      const applyRules = (data, rules) => {
        // Iterate through each rule
        rules.forEach((rule) => {
          // Check the strategy of the rule
          switch (rule.strategy) {
            case "hash":
              // Filter out tags based on hash strategy
              data = data.filter(
                (tag) =>
                  !rule.tags.some(
                    ({ tag_value }) => tag.tag_value === tag_value
                  )
              );
              break;
            case "remove":
              // Filter out tags based on remove strategy
              data = data.filter(
                (tag) =>
                  !rule.tags.some(
                    ({ tag_value }) => tag.tag_value === tag_value
                  )
              );
              break;
            case "empty":
              // Filter out tags based on empty strategy
              data = data.filter(
                (tag) =>
                  !rule.tags.some(
                    ({ tag_value }) => tag.tag_value === tag_value
                  )
              );
              break;
            case "preserve":
              // Filter out tags based on preserve strategy
              data = data.filter(
                (tag) =>
                  !rule.tags.some(
                    ({ tag_value }) => tag.tag_value === tag_value
                  )
              );
              break;
            case "exclude":
              // Filter out tags based on preserve strategy
              data = data.filter(
                (tag) =>
                  !rule.tags.some(
                    ({ tag_value }) => tag.tag_value === tag_value
                  )
              );
            case "fixed_value":
              // Filter out tags based on empty strategy
              data = data.filter(
                (tag) =>
                  !rule.tags.some(
                    ({ tag_value }) => tag.tag_value === tag_value
                  )
              );
              break;
            default:
              // Unsupported strategy
              console.error(`Unsupported strategy: ${rule.strategy}`);
          }
        });
        return data;
      };

      const filteredData = applyRules(data, rules);
      setData(filteredData);
      setData2(filteredData);
      setData3(filteredData);
      setData4(filteredData);
      setData5(filteredData);
      setData6(filteredData);
    }
  }, [editData, data, data2, data3, data4, data5, data6]);

  useEffect(() => {
    if (Object.keys(editData).length) {
      const parsedRules = JSON.parse(editData.rules);
      setName(editData.name);
      setId(editData.id);

      // Create an object to store the values based on keys
      const ruleValues = {
        hash: null,
        remove: null,
        empty: null,
        fixed_value: null,
        preserve: null,
        exclude: null,
      };

      // Iterate over the parsedRules and assign values based on the strategy
      parsedRules.forEach((rule) => {
        const { strategy, tags } = rule;
        ruleValues[strategy] = tags;
      });

      // Now you can access values using keys
      setEditHash(ruleValues["hash"]);
      setEditRemove(ruleValues["remove"]);
      setEditEmpty(ruleValues["empty"]);
      setEditFixedValue(ruleValues["fixed_value"]);
      setEditPreserve(ruleValues["preserve"]);
      setEditexclude(ruleValues["exclude"]);

      ruleValues["preserve"] && ruleValues["preserve"].length > 0
        ? setshowPreserveTags(true)
        : setshowPreserveTags(false);
      setRules(parsedRules);
      setfixedSelectedValue(ruleValues["fixed_value"]);

      const fixedValuess = ruleValues["fixed_value"]
        ? ruleValues["fixed_value"].map((item) => item.fixed_value)
        : [];
      setFixedValue(fixedValuess);
    }
  }, [editData]);

  const setFixedValueAtIndex = (index, newValue) => {
    const updatedFixedValue = [...fixedValue]; // Create a copy of the array
    updatedFixedValue[index] = newValue.trimStart();

    setFixedValue(updatedFixedValue); // Set the updated array
  };

  const modalStyles = {
    color: "white",
    fontWeight: "bold",
    position: "absolute",
    top: 0,
    right: 0,
    width: "40%",
    padding: "2rem",
    height: "100vh",
    backdropFilter: "blur(14.5px)",
    background: "transparent",
    boxShadow: " 0 0 6px 0 rgba(149,149,149,0.5)",
  };

  const handleclick = () => {
    handleclickcustom();
  };

  const handleprotocol = async (e) => {
    e.preventDefault();
    if (!name) {
      seterror(true);
      setTimeout(() => {
        seterror(false);
      }, 2000);
      return;
    }

    // if (fixedValue.length === 0 || fixedValue.includes("")) {
    //   setfixedError(true);
    //   setTimeout(() => {
    //     setfixedError(false);
    //   }, 2000);
    //   return;
    // }
    // if (fixedValue.length < fixedSelectedValue.length) {
    //   setfixedError(true);
    //   setTimeout(() => {
    //     setfixedError(false);
    //   }, 2000);
    //   return;
    // }

    const SendData = async () => {
      let filterobj = {};
      let filterobj2 = [];
      filterobj2 = rules;
      for (let i = 0; i < filterobj2.length; i++) {
        if (filterobj2[i].strategy === "fixed_value") {
          for (let j = 0; j < filterobj2[i].tags.length; j++) {
            filterobj2[i].tags[j].fixed_value =
              fixedValue && fixedValue[j] && fixedValue[j].trim();
          }
        }
      }
      filterobj = { name: name, rules: JSON.stringify(filterobj2) };

      try {
        const response = await axiosInstance.post(
          `${ADD_ANON_PROTOCOL}`,
          filterobj,
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );
        setName("");
        setRules([]);
        if (response.data.success) {
          toast.success(`${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          props.setUpdate((state) => !state);
          setTimeout(() => {
            props.handleClose();
          }, 1000);
        } else {
          toast.error(`Error: ${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };
    SendData();
  };

  const handleEditprotocol = async (e) => {
    e.preventDefault();
    if (!name) {
      seterror(true);
      setTimeout(() => {
        seterror(false);
      }, 2000);
      return;
    }

    // if (
    //   (fixedValue &&
    //     fixedValue.length < fixedSelectedValue &&
    //     fixedSelectedValue.length) ||
    //   (fixedValue && fixedValue.includes(""))
    // ) {
    //   setfixedError(true);
    //   setTimeout(() => {
    //     setfixedError(false);
    //   }, 2000);
    //   return;
    // }

    const SendData = async () => {
      let filterobj = {};
      let filterobj2 = [];
      filterobj2 = rules;
      for (let i = 0; i < filterobj2.length; i++) {
        if (filterobj2[i].strategy === "fixed_value") {
          for (let j = 0; j < filterobj2[i].tags.length; j++) {
            filterobj2[i].tags[j].fixed_value =
              fixedValue && fixedValue[j] && fixedValue[j].trim();
          }
        }
      }
      filterobj = { name: name, id: id, rules: JSON.stringify(filterobj2) };
      try {
        const response = await axiosInstance.put(
          `${UPDATE_ANON_PROTOCOL}`,
          filterobj,
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );
        setName("");
        setRules([]);
        setEditHash([]);
        setEditRemove([]);
        setEditEmpty([]);
        setEditPreserve([]);
        setEditFixedValue([]);
        setEditexclude([]);
        if (response.data.success) {
          toast.success(`${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          props.setUpdate((state) => !state);
          setTimeout(() => {
            props.handleClose();
          }, 1000);
        } else {
          toast.error(`Error: ${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };
    SendData();
  };

  function onSelect(selectedList) {
    let DataTags = selectedList.map((item) => item.tag_description);

    let existingIndex = rules.findIndex((rule) => rule.strategy === "hash");
    if (existingIndex !== -1) {
      let updatedRules = [...rules];
      updatedRules[existingIndex] = {
        ...updatedRules[existingIndex],
        tags: selectedList,
      };
      setRules(updatedRules);
    } else {
      let obj = { strategy: "hash", tags: selectedList };
      setRules((prevrules) => [...prevrules, obj]);
    }
    let remainingData = data.filter(
      (item) => !DataTags.includes(item.tag_description)
    );
    setData2(remainingData);
    setData3(remainingData);
    setData4(remainingData);
    setData5(remainingData);
    setData6(remainingData);
  }
  function onRemove(selectedList, removeitem) {
    const DataTags = selectedList.map((item) => item.tag_description);

    const existingIndex = rules.findIndex((rule) => rule.strategy === "hash");
    if (existingIndex !== -1) {
      const updatedRules = [...rules];
      updatedRules[existingIndex] = {
        ...updatedRules[existingIndex],
        tags: selectedList,
      };
      setRules(updatedRules);
    } else {
      const obj = { strategy: "hash", tags: selectedList };

      setRules((prevrules) => [...prevrules, obj]);
    }
    const remainingData = data.filter(
      (item) => !DataTags.includes(item.tag_description)
    );

    let objectSet = new Set(
      editHash && editHash.map((obj) => JSON.stringify(obj))
    );

    let newObjString = JSON.stringify(removeitem);

    if (!objectSet.has(newObjString)) {
      objectSet.add(newObjString);
    }
    let newedithash = Array.from(objectSet, (obj) => JSON.parse(obj));

    const output = newedithash.filter(
      (tag) => !DataTags.includes(tag.tag_description)
    );
    const combinedArray = [...remainingData, ...output];
    const uniqueObjects = Array.from(
      new Set(combinedArray.map((obj) => JSON.stringify(obj)))
    ).map((str) => JSON.parse(str));

    if (editHash) {
      setData(uniqueObjects);
      setData2(uniqueObjects);
      setData3(uniqueObjects);
      setData4(uniqueObjects);
      setData5(uniqueObjects);
      setData6(uniqueObjects);
    } else {
      setData2(remainingData);
      setData3(remainingData);
      setData4(remainingData);
      setData5(remainingData);
      setData6(remainingData);
    }
  }

  function onSelect1(selectedList) {
    let DataTags = selectedList.map((item) => item.tag_description);
    let existingIndex = rules.findIndex((rule) => rule.strategy === "remove");
    if (existingIndex !== -1) {
      const updatedRules = [...rules];
      updatedRules[existingIndex] = {
        ...updatedRules[existingIndex],
        tags: selectedList,
      };
      setRules(updatedRules);
    } else {
      let obj = { strategy: "remove", tags: selectedList };
      setRules((prevrules) => [...prevrules, obj]);
    }
    let remainingData = data2.filter(
      (item) => !DataTags.includes(item.tag_description)
    );
    setData(remainingData);
    setData3(remainingData);
    setData4(remainingData);
    setData5(remainingData);
    setData6(remainingData);
  }
  function onRemove1(selectedList, removeditem) {
    const DataTags = selectedList.map((item) => item.tag_description);
    const existingIndex = rules.findIndex((rule) => rule.strategy === "remove");
    if (existingIndex !== -1) {
      const updatedRules = [...rules];
      updatedRules[existingIndex] = {
        ...updatedRules[existingIndex],
        tags: selectedList,
      };
      setRules(updatedRules);
    } else {
      const obj = { strategy: "remove", tags: selectedList };
      setRules((prevrules) => [...prevrules, obj]);
    }
    let remainingData =
      data2 && data2.filter((item) => !DataTags.includes(item.tag_description));

    let objectSet = new Set(
      editRemove && editRemove.map((obj) => JSON.stringify(obj))
    );

    let newObjString = JSON.stringify(removeditem);

    if (!objectSet.has(newObjString)) {
      objectSet.add(newObjString);
    }
    let neweditremove = Array.from(objectSet, (obj) => JSON.parse(obj));
    const output = neweditremove.filter(
      (tag) => !DataTags.includes(tag.tag_description)
    );
    let combinedArray = [...remainingData, ...output];
    let uniqueObjects = Array.from(
      new Set(combinedArray.map((obj) => JSON.stringify(obj)))
    ).map((str) => JSON.parse(str));

    if (editRemove) {
      setData(uniqueObjects);
      setData2(uniqueObjects);
      setData3(uniqueObjects);
      setData4(uniqueObjects);
      setData5(uniqueObjects);
      setData6(uniqueObjects);
    } else {
      setData2(remainingData);
      setData3(remainingData);
      setData4(remainingData);
      setData5(remainingData);
      setData6(remainingData);
    }
  }
  function onSelect2(selectedList) {
    const DataTags = selectedList.map((item) => item.tag_description);
    const existingIndex = rules.findIndex((rule) => rule.strategy === "empty");
    if (existingIndex !== -1) {
      let updatedRules = [...rules];
      updatedRules[existingIndex] = {
        ...updatedRules[existingIndex],
        tags: selectedList,
      };
      setRules(updatedRules);
    } else {
      let obj = { strategy: "empty", tags: selectedList };
      setRules((prevrules) => [...prevrules, obj]);
    }
    const remainingData = data3.filter(
      (item) => !DataTags.includes(item.tag_description)
    );
    setData(remainingData);
    setData2(remainingData);
    setData4(remainingData);
    setData5(remainingData);
    setData6(remainingData);
  }
  function onRemove2(selectedList, removeditem) {
    let DataTags = selectedList.map((item) => item.tag_description);
    let existingIndex = rules.findIndex((rule) => rule.strategy === "empty");
    if (existingIndex !== -1) {
      const updatedRules = [...rules];
      updatedRules[existingIndex] = {
        ...updatedRules[existingIndex],
        tags: selectedList,
      };
      setRules(updatedRules);
    } else {
      let obj = { strategy: "empty", tags: selectedList };
      setRules((prevrules) => [...prevrules, obj]);
    }
    let remainingData =
      data3 && data3.filter((item) => !DataTags.includes(item.tag_description));

    let objectSet = new Set(
      editEmpty && editEmpty.map((obj) => JSON.stringify(obj))
    );

    let newObjString = JSON.stringify(removeditem);

    if (!objectSet.has(newObjString)) {
      objectSet.add(newObjString);
    }
    let neweditEmpty = Array.from(objectSet, (obj) => JSON.parse(obj));
    let output = neweditEmpty.filter(
      (tag) => !DataTags.includes(tag.tag_description)
    );
    let combinedArray = [...remainingData, ...output];
    let uniqueObjects = Array.from(
      new Set(combinedArray.map((obj) => JSON.stringify(obj)))
    ).map((str) => JSON.parse(str));

    if (editEmpty) {
      setData(uniqueObjects);
      setData2(uniqueObjects);
      setData3(uniqueObjects);
      setData4(uniqueObjects);
      setData5(uniqueObjects);
      setData6(uniqueObjects);
    } else {
      setData2(remainingData);
      setData3(remainingData);
      setData4(remainingData);
      setData5(remainingData);
      setData6(remainingData);
    }
  }
  function onSelect3(selectedList) {
    setfixedSelectedValue(selectedList);
    let DataTags = selectedList.map((item) => item.tag_description);
    let existingIndex = rules.findIndex(
      (rule) => rule.strategy === "fixed_value"
    );
    if (existingIndex !== -1) {
      let updatedRules = [...rules];
      updatedRules[existingIndex] = {
        ...updatedRules[existingIndex],
        tags: selectedList,
      };
      setRules(updatedRules);
    } else {
      let obj = { strategy: "fixed_value", tags: selectedList };
      setRules((prevrules) => [...prevrules, obj]);
    }
    const remainingData = data4.filter(
      (item) => !DataTags.includes(item.tag_description)
    );
    setData(remainingData);
    setData2(remainingData);
    setData3(remainingData);
    setData5(remainingData);
    setData6(remainingData);
  }
  function onRemove3(selectedList, removeditem) {
    setfixedSelectedValue(selectedList);
    const DataTags = selectedList.map((item) => item.tag_description);
    const existingIndex = rules.findIndex(
      (rule) => rule.strategy === "fixed_value"
    );
    if (existingIndex !== -1) {
      const updatedRules = [...rules];
      updatedRules[existingIndex] = {
        ...updatedRules[existingIndex],
        tags: selectedList,
      };
      setRules(updatedRules);
    } else {
      const obj = {
        strategy: "fixed_value",
        tags: selectedList,
      };
      setRules((prevrules) => [...prevrules, obj]);
    }
    const remainingData =
      data4 && data4.filter((item) => !DataTags.includes(item.tag_description));

    let objectSet = new Set(
      editFixedValue && editFixedValue.map((obj) => JSON.stringify(obj))
    );

    let newObjString = JSON.stringify(removeditem);

    if (!objectSet.has(newObjString)) {
      objectSet.add(newObjString);
    }
    let neweditFixedValue = Array.from(objectSet, (obj) => JSON.parse(obj));

    const output = neweditFixedValue.filter(
      (tag) => !DataTags.includes(tag.tag_description)
    );
    const combinedArray = [...remainingData, ...output];
    const uniqueObjects = Array.from(
      new Set(combinedArray.map((obj) => JSON.stringify(obj)))
    ).map((str) => JSON.parse(str));

    if (editFixedValue) {
      setData(uniqueObjects);
      setData2(uniqueObjects);
      setData3(uniqueObjects);
      setData4(uniqueObjects);
      setData5(uniqueObjects);
      setData6(uniqueObjects);
    } else {
      setData2(remainingData);
      setData3(remainingData);
      setData4(remainingData);
      setData5(remainingData);
      setData6(remainingData);
    }
  }
  function onSelect4(selectedList) {
    setpreservetaglist(selectedList);
    let DataTags = selectedList.map((item) => item.tag_description);
    let existingIndex = rules.findIndex((rule) => rule.strategy === "preserve");
    if (existingIndex !== -1) {
      let updatedRules = [...rules];
      updatedRules[existingIndex] = {
        ...updatedRules[existingIndex],
        tags: selectedList,
      };
      setRules(updatedRules);
    } else {
      let obj = { strategy: "preserve", tags: selectedList };
      setRules((prevrules) => [...prevrules, obj]);
    }
    const remainingData = data2.filter(
      (item) => !DataTags.includes(item.tag_description)
    );
    setData(remainingData);
    setData2(remainingData);
    setData3(remainingData);
    setData4(remainingData);
    setData6(remainingData);
  }
  function onRemove4(selectedList, removeditem) {
    setpreservetaglist(selectedList);
    let DataTags = selectedList.map((item) => item.tag_description);
    let existingIndex = rules.findIndex((rule) => rule.strategy === "preserve");
    if (existingIndex !== -1) {
      let updatedRules = [...rules];
      updatedRules[existingIndex] = {
        ...updatedRules[existingIndex],
        tags: selectedList,
      };
      setRules(updatedRules);
    } else {
      let obj = { strategy: "preserve", tags: selectedList };
      setRules((prevrules) => [...prevrules, obj]);
    }
    const remainingData =
      data5 && data5.filter((item) => !DataTags.includes(item.tag_description));
    let objectSet = new Set(
      editPreserve && editPreserve.map((obj) => JSON.stringify(obj))
    );

    let newObjString = JSON.stringify(removeditem);

    if (!objectSet.has(newObjString)) {
      objectSet.add(newObjString);
    }
    let neweditPreserve = Array.from(objectSet, (obj) => JSON.parse(obj));

    let output = neweditPreserve.filter(
      (tag) => !DataTags.includes(tag.tag_description)
    );
    const combinedArray = [...remainingData, ...output];
    const uniqueObjects = Array.from(
      new Set(combinedArray.map((obj) => JSON.stringify(obj)))
    ).map((str) => JSON.parse(str));

    if (editPreserve) {
      setData(uniqueObjects);
      setData2(uniqueObjects);
      setData3(uniqueObjects);
      setData4(uniqueObjects);
      setData5(uniqueObjects);
      setData6(uniqueObjects);
    } else {
      setData2(remainingData);
      setData3(remainingData);
      setData4(remainingData);
      setData5(remainingData);
      setData6(remainingData);
    }
  }
  function onSelect5(selectedList) {
    setexcludetaglist(selectedList);
    let DataTags = selectedList.map((item) => item.tag_description);

    let existingIndex = rules.findIndex((rule) => rule.strategy === "exclude");
    if (existingIndex !== -1) {
      let updatedRules = [...rules];
      updatedRules[existingIndex] = {
        ...updatedRules[existingIndex],
        tags: selectedList,
      };
      setRules(updatedRules);
    } else {
      let obj = { strategy: "exclude", tags: selectedList };
      setRules((prevrules) => [...prevrules, obj]);
    }
    let remainingData = data6.filter(
      (item) => !DataTags.includes(item.tag_description)
    );
    setData(remainingData);
    setData2(remainingData);
    setData3(remainingData);
    setData4(remainingData);
    setData5(remainingData);
  }
  function onRemove5(selectedList, removeitem) {
    setexcludetaglist(selectedList);
    const DataTags = selectedList.map((item) => item.tag_description);

    const existingIndex = rules.findIndex(
      (rule) => rule.strategy === "exclude"
    );
    if (existingIndex !== -1) {
      const updatedRules = [...rules];
      updatedRules[existingIndex] = {
        ...updatedRules[existingIndex],
        tags: selectedList,
      };
      setRules(updatedRules);
    } else {
      const obj = { strategy: "exclude", tags: selectedList };

      setRules((prevrules) => [...prevrules, obj]);
    }
    const remainingData = data6.filter(
      (item) => !DataTags.includes(item.tag_description)
    );

    let objectSet = new Set(
      editexclude && editexclude.map((obj) => JSON.stringify(obj))
    );

    let newObjString = JSON.stringify(removeitem);

    if (!objectSet.has(newObjString)) {
      objectSet.add(newObjString);
    }
    let neweditExclude = Array.from(objectSet, (obj) => JSON.parse(obj));

    const output = neweditExclude.filter(
      (tag) => !DataTags.includes(tag.tag_description)
    );
    const combinedArray = [...remainingData, ...output];
    const uniqueObjects = Array.from(
      new Set(combinedArray.map((obj) => JSON.stringify(obj)))
    ).map((str) => JSON.parse(str));

    if (editexclude) {
      setData(uniqueObjects);
      setData2(uniqueObjects);
      setData3(uniqueObjects);
      setData4(uniqueObjects);
      setData5(uniqueObjects);
    } else {
      setData2(remainingData);
      setData(remainingData);
      setData3(remainingData);
      setData4(remainingData);
      setData5(remainingData);
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(`${GET_DICOM_TAGS}`, {
          headers: {
            Authorization: `Bearer ${localStorage.access_token}`,
          },
        });
        setData(response.data);
        setData2(response.data);
        setData3(response.data);
        setData4(response.data);
        setData5(response.data);
        setData6(response.data);
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };

    fetchData();
  }, []);

  const handleMDPApproach = () => {
    if (preservetaglist) {
      let result = data;
      let output = [...result, ...preservetaglist];
      setData(output);
      setData2(output);
      setData3(output);
      setData4(output);
      setData5(output);
      setData6(output);
      setpreservetaglist("");
      setexcludetaglist("");
      setEditPreserve([]);
      setEditexclude([]);
    }
    if (excludetaglist) {
      let result = data;
      let output = [...result, ...excludetaglist];
      setData(output);
      setData2(output);
      setData3(output);
      setData4(output);
      setData5(output);
      setData6(output);
      setpreservetaglist("");
      setexcludetaglist("");
      setEditPreserve([]);
      setEditexclude([]);
    }
    if (editPreserve && (editPreserve.length > 0) & !preservetaglist) {
      let final = rules && rules.filter((item) => item.strategy !== "preserve");
      let result = data;
      let output = [...result, ...editPreserve];
      setData(output);
      setData2(output);
      setData3(output);
      setData4(output);
      setData5(output);
      setData6(output);
      setpreservetaglist("");
      setexcludetaglist("");
      setEditPreserve([]);
      setEditexclude([]);
      setRules(final);
    }
    if (editexclude && (editexclude.length > 0) & !excludetaglist) {
      let final = rules && rules.filter((item) => item.strategy !== "exclude");

      let result = data;
      let output = [...result, ...editexclude];
      setData(output);
      setData2(output);
      setData3(output);
      setData4(output);
      setData5(output);
      setData6(output);
      setpreservetaglist("");
      setexcludetaglist("");
      setEditPreserve([]);
      setEditexclude([]);
      setRules(final);
    }

    setshowPreserveTags((state) => !state);
  };

  return (
    <div>
      <React.StrictMode>
        <Modal onClose={props.handleClose} open={props.ModalState}>
          <Box sx={modalStyles} style={{ overflowY: "auto" }}>
            <div className="d-flex justify-content-between align-items-center text-light ">
              <div>
                <div
                  className="h5 font-weight-bold  mt-2"
                  style={{ fontFamily: "Montserrat" }}
                >
                  Add Anon Protocol
                </div>
              </div>

              <IconButton onClick={props.handleClose} aria-label="close">
                <CloseIcon className="text-light" />
              </IconButton>
            </div>
            <div className="mt-2">
              <div
                className=" pl-3"
                style={{
                  color: "#12f0c1",
                  fontWeight: "normal",
                  fontSize: "14px",
                  fontFamily: "montserrat",
                }}
              >
                Name*
              </div>
              <div>
                <input
                  required
                  id="name"
                  label="Name"
                  onChange={(e) => setName(e.target.value.trimStart())}
                  className="text-input-modal mt-1"
                  placeholder="Name"
                  value={name}
                />
                {!name && error && (
                  <span className="errorStyles">NAME Required</span>
                )}
              </div>
              <div
                style={{
                  color: "#12f0c1",
                  fontWeight: "normal",
                  fontSize: "14px",
                  fontFamily: "montserrat",
                  marginTop: "11px",
                }}
              >
                <input
                  className="preserve-checkbox"
                  type="checkbox"
                  onClick={handleMDPApproach}
                  checked={showPreserveTags}
                />
                Use MetaData Preservation Approach
              </div>
              {data && (
                <div>
                  {showPreserveTags && (
                    <div className="mt-3">
                      <Multiselect
                        options={data5}
                        displayValue="tag_description"
                        onSelect={onSelect4}
                        onRemove={onRemove4}
                        placeholder="Preserve Tags"
                        style={{
                          chips: { background: "black", fontWeight: "normal" },
                          multiselectContainer: {
                            background: "#1A2C2B",
                            border: "1px solid #0f9077",
                            borderRadius: "5px",
                            outline: "none",
                          },
                          searchBox: {
                            border: "none",
                          },
                          inputField: {
                            // To change input field position or margin
                            color: "white",
                          },
                          option: {
                            background: "black",
                            color: "#FFFFFF",
                            fontWeight: "normal",
                          },
                        }}
                        selectedValues={editPreserve}
                      />
                    </div>
                  )}
                  <div className="mt-3">
                    <Multiselect
                      options={data}
                      displayValue="tag_description"
                      onSelect={onSelect}
                      onRemove={onRemove}
                      style={{
                        chips: { background: "black", fontWeight: "normal" },
                        multiselectContainer: {
                          background: "#1A2C2B",
                          border: "1px solid #0f9077",
                          borderRadius: "5px",
                          outline: "none",
                        },
                        searchBox: {
                          border: "none",
                        },
                        inputField: {
                          // To change input field position or margin
                          color: "white",
                        },
                        option: {
                          background: "black",
                          color: "#FFFFFF",
                          fontWeight: "normal",
                        },
                      }}
                      placeholder="Hash Tags"
                      selectedValues={editHash}
                    />
                  </div>
                  <div className="mt-3">
                    <Multiselect
                      options={data2}
                      displayValue="tag_description"
                      onSelect={onSelect1}
                      onRemove={onRemove1}
                      placeholder="Remove Tags"
                      selectedValues={editRemove}
                      style={{
                        chips: { background: "black", fontWeight: "normal" },
                        multiselectContainer: {
                          background: "#1A2C2B",
                          border: "1px solid #0f9077",
                          borderRadius: "5px",
                          outline: "none",
                        },
                        searchBox: {
                          border: "none",
                        },
                        inputField: {
                          // To change input field position or margin
                          color: "white",
                        },
                        option: {
                          background: "black",
                          color: "#FFFFFF",
                          fontWeight: "normal",
                        },
                      }}
                    />
                  </div>
                  {!showPreserveTags && (
                    <div className="mt-3">
                      <Multiselect
                        options={data6}
                        displayValue="tag_description"
                        onSelect={onSelect5}
                        onRemove={onRemove5}
                        placeholder="exclude tags"
                        style={{
                          chips: { background: "black", fontWeight: "normal" },
                          multiselectContainer: {
                            background: "#1A2C2B",
                            border: "1px solid #0f9077",
                            borderRadius: "5px",
                            outline: "none",
                          },
                          searchBox: {
                            border: "none",
                          },
                          inputField: {
                            // To change input field position or margin
                            color: "white",
                          },
                          option: {
                            background: "black",
                            color: "#FFFFFF",
                            fontWeight: "normal",
                          },
                        }}
                        selectedValues={editexclude}
                      />
                    </div>
                  )}
                  <div className="mt-3">
                    <Multiselect
                      options={data3}
                      displayValue="tag_description"
                      onSelect={onSelect2}
                      onRemove={onRemove2}
                      placeholder="Empty Tags"
                      style={{
                        chips: { background: "black", fontWeight: "normal" },
                        multiselectContainer: {
                          background: "#1A2C2B",
                          border: "1px solid #0f9077",
                          borderRadius: "5px",
                          outline: "none",
                        },
                        searchBox: {
                          border: "none",
                        },
                        inputField: {
                          // To change input field position or margin
                          color: "white",
                        },
                        option: {
                          background: "black",
                          color: "#FFFFFF",
                          fontWeight: "normal",
                        },
                      }}
                      selectedValues={editEmpty}
                    />
                  </div>

                  <div className="mt-3">
                    <Multiselect
                      options={data4}
                      displayValue="tag_description"
                      onSelect={onSelect3}
                      onRemove={onRemove3}
                      placeholder="Fixed Value Tags"
                      style={{
                        chips: { background: "black", fontWeight: "normal" },
                        multiselectContainer: {
                          background: "#1A2C2B",
                          border: "1px solid #0f9077",
                          borderRadius: "5px",
                          outline: "none",
                        },
                        searchBox: {
                          border: "none",
                        },
                        inputField: {
                          // To change input field position or margin
                          color: "white",
                        },
                        option: {
                          background: "black",
                          color: "#FFFFFF",
                          fontWeight: "normal",
                        },
                      }}
                      selectedValues={editFixedValue}
                    />
                  </div>
                  <div className="mt-3">
                    {fixedSelectedValue &&
                      fixedSelectedValue.map((value, index) => (
                        <>
                          <pspan>{value.tag_description}</pspan>
                          <input
                            key={index} // Make sure to provide a unique key for each input
                            className="text-input-modal mt-1"
                            id={`FixedValue-${index}`}
                            label={`FixedValue-${index}`}
                            onChange={(e) =>
                              setFixedValueAtIndex(index, e.target.value)
                            }
                            value={fixedValue?.[index] || ""}
                            placeholder={`Fixed value for ${value.tag_description}`}
                          />
                          {fixedError &&
                            (fixedValue[index] === undefined ||
                              fixedValue[index] === "") && (
                              <div className="errorStyles pt-1">
                                {" "}
                                Value Required
                              </div>
                            )}
                        </>
                      ))}
                  </div>
                </div>
              )}
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <span
                  onClick={handleclick}
                  style={{
                    color: "#0fc4a0",
                    textDecoration: "underline", // Adds underline like a link
                    cursor: "pointer",
                  }}
                >
                  ADD CUSTOM TAG
                </span>
              </div>
              <div>
                <div>
                  <Button
                    type="button"
                    className="btn-class"
                    style={{ marginTop: "0px" }}
                    onClick={
                      Object.keys(editData).length
                        ? handleEditprotocol
                        : handleprotocol
                    }
                  >
                    SUBMIT
                  </Button>
                </div>
              </div>
            </div>
            {!showPreserveTags && (
              <div>
                <div
                  style={{
                    fontFamily: "Montserrat",
                  }}
                >
                  <hr></hr>
                  <div className="default-tags">
                    <h6>The following data tags are anonymized by default:</h6>
                    <ul className="default-tags">
                      <li>AccessionNumber</li>
                      <li>AcquisitionDate</li>
                      <li>AdmissionID</li>
                      <li>AdmittingDate</li>
                      <li>AdmittingTime</li>
                      <li>ContributingEquipmentSequence</li>
                      <li>ContentDate</li>
                      <li>DeviceSerialNumber</li>
                      <li>InstitutionName</li>
                      <li>IssuerOfPatientID</li>
                      <li>PatientAge</li>
                      <li>PatientBirthDate</li>
                      <li>PatientBirthTime</li>
                      <li>PatientID</li>
                      <li>PatientName</li>
                      <li>PerformingPhysicianName</li>
                      <li>PerformedProcedureStepID</li>
                      <li>PerformedProcedureStepStartDate</li>
                      <li>PerformedProcedureStepStartTime</li>
                      <li>PhysiciansOfRecord</li>
                      <li>ProtocolName</li>
                      <li>ReferringPhysicianName</li>
                      <li>RequestedProcedureDescription</li>
                      <li>RequestedProcedureID</li>
                      <li>RequestingPhysician</li>
                      <li>ScheduledProcedureStepID</li>
                      <li>ScheduledProcedureStepStartDate</li>
                      <li>ScheduledProcedureStepStartDateTime</li>
                      <li>ScheduledProcedureStepStartTime</li>
                      <li>SeriesDate</li>
                      <li>SoftwareVersions</li>
                      <li>SourceApplicationEntityTitle</li>
                      <li>StationName</li>
                      <li>StudyDate</li>
                      <li>StudyInstanceUID</li>
                    </ul>
                    <hr></hr>
                    <p>
                      <em>
                        *Please note that excluding tags from anonymization may
                        expose personally identifiable information, which could
                        impact patient privacy and confidentiality. We strongly
                        recommend exercising caution when choosing to exclude
                        any tags.
                      </em>
                    </p>
                  </div>
                </div>
              </div>
            )}
          </Box>
        </Modal>
      </React.StrictMode>
    </div>
  );
};
export default AddProtocolModal;
